import { createFileRoute } from '@tanstack/react-router'
import { bankStatementQueryOptions } from '../../../features/bank/queries'
import { bankStatementPageSearchSchema } from '../../../features/bank/search'
import { StatementPage } from '../../../features/bank/statement-page'

export const Route = createFileRoute('/_app/bank-statements/$statementId')({
  staticData: { crumb: 'bankStatement' },
  validateSearch: bankStatementPageSearchSchema,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(bankStatementQueryOptions(params.statementId)),
  component: StatementPage,
})
